import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogTimeSavedComponent } from '@app/modules/settings/components/dialog-time-saved/dialog-time-saved.component';

@Component({
  standalone: false,
  selector: 'sbnb-cancel-subscription-card',
  template: `
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div class="night">No longer need help automating your operations?</div>

      <sbnb-button (click)="openCancelSubscriptionInterstitial()" type="secondary" size="mini" id="cancel-subscription">
        Cancel anytime
      </sbnb-button>
    </div>
  `,
  styles: [],
  styleUrls: ['../../../../../churnkey.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelSubscriptionCardComponent implements OnInit {
  constructor(private readonly dialog: MatDialog) { }

  ngOnInit(): void { }

  public openCancelSubscriptionInterstitial() {
    this.dialog.open(DialogTimeSavedComponent, {
      width: '32rem',
      height: '500px',
      maxHeight: '90vh',
    });
  }
}
